module.exports = __webpack_public_path__ + "static/media/add_app_home.eb1ed0a5.png";